import { Modal as BootstrapModal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

type Button = {
	label: string;
	onClick: () => void;
};

interface IProps {
	headerIcon: JSX.Element;
	headerText: string;
	bodyContent: JSX.Element;
	isOpen: boolean;
	close: () => void;
	buttonFull?: Button;
	buttonOutlined?: Button;
	size?: 'sm' | 'lg' | 'xl';
}

const Modal = (props: IProps) => {
	const { t } = useTranslation();
	return (
		<BootstrapModal
			show={props.isOpen}
			onHide={() => props.close()}
			aria-labelledby="contained-modal-title-vcenter"
			size={props.size ?? 'xl'}
			centered
		>
			<div className="modal-content">
				<div className="modal-header">
					<div
						style={{
							marginRight: '1rem',
							marginLeft: '1rem',
						}}
					>
						{props.headerIcon}
					</div>
					{props.headerText}
					<button className="btn close" aria-label="Close" onClick={() => props.close()}>
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div className="modal-body">{props.bodyContent}</div>
				<div className="modal-footer">
					{props.buttonOutlined && (
						<button
							className="btn btn-outline-secondary"
							onClick={props.buttonOutlined.onClick}
						>
							{props.buttonOutlined.label ?? t('_general:BTN_LEAVE')}
						</button>
					)}
					{props.buttonFull && (
						<button className="btn btn-secondary" onClick={props.buttonFull.onClick}>
							{props.buttonFull.label}
						</button>
					)}
				</div>
			</div>
		</BootstrapModal>
	);
};

export default Modal;
